import moment from 'moment';

export const STANDARD_DATE = 'MM/DD/YYYY';
export const FULL_DATE = 'MM/DD/YYYY hh:mm A';
export const FULL_DATE_WITH_TZ = 'MM/DD/YYYY hh:mm A z';

export const APPOINTMENT_DATE_FORMAT = 'ddd, MMM, DD';
export const MEDICATION_DATE_FORMAT = 'DD MMM yyyy';
export const POLICY_DATE_FORMAT = 'D MMMM YYYY';
export const MONTH_DATE_FORMAT = 'MMMM YYYY';
export const ACTIVITIES_DATE_FORMAT_WITH_TIMEZONE =
  'dddd, MM/DD/YYYY hh:mm a z';
export const FULL_APPOINTMENT_DATE_FORMAT_WITH_FULL_MONTH =
  'dddd, MMMM DD, YYYY hh:mm A z';
export const MEDICATION_FORMAT = 'MMM DD, YYYY';
export const SUBSCRIPTION_FORMAT = 'MMM. DD, YYYY';
export const TIME_FORMAT = 'hh:mm A';
export const FULL_APPOINTMENT_DATE_FOR_TABLE_FORMAT = 'MMM DD, YYYY hh:mm A z';
export const BALANCE_FORMAT = 'ddd, MMM DD, YYYY';

export const getAppointmentFullTimeDate = (date: string | undefined) => {
  if (!date) {
    return;
  }
  const time = moment(date);
  return time.format(FULL_DATE);
};

export const getAppointmentDate = (date: string | undefined) => {
  if (!date) {
    return '';
  }
  const time = moment(date);
  return time.format(APPOINTMENT_DATE_FORMAT);
};

export const get12HourFormat = (date: string | undefined) => {
  if (!date) {
    return '';
  }
  const [hour, min] = date.split(':');
  const time = moment().hour(+hour).minutes(+min);
  return time.format(TIME_FORMAT);
};

export const getRemainingTimeToRequestCode = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes < 10 ? '0' : ''}${minutes}:${
    remainingSeconds < 10 ? '0' : ''
  }${remainingSeconds}`;
};
